import { render, staticRenderFns } from "./playgame.vue?vue&type=template&id=2848e670&scoped=true&"
import script from "./playgame.vue?vue&type=script&lang=js&"
export * from "./playgame.vue?vue&type=script&lang=js&"
import style0 from "./playgame.vue?vue&type=style&index=0&id=2848e670&lang=scss&scoped=true&"
import style1 from "./playgame.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2848e670",
  null
  
)

export default component.exports